import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const MondiaPayDenmarkIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection`;
      };
    },
    // ----------- reSub/unSub methods ----------------------------------
    alternateReSubActionImpl() {
      return (msisdn, operator) => {
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection`;
      }
      //   this.clearLoginInfo(); // logout
      //   window.location.href = `${window.location.origin}/api/preparePurchase?msisdn=${msisdn || ''}&lang=${this.getLocale || ''}&webflow=true`;
      // };
    },
  },
};

export default MondiaPayDenmarkIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/mondiaPayDenmarkIntegration.js